const PHASE_LABELS = {
  started: 'Started',
  completed: 'Complete',
  failed: 'Failed',
};

const TECHNICAL_MARKERS = [
  'sqlalchemy',
  'asyncpg',
  'traceback',
  'integrityerror',
  '<class ',
  'duplicate key',
  'uniqueviolation',
  'postgresql',
  'detailed message:',
];

export function phaseLabel(phase) {
  if (!phase) return null;
  return PHASE_LABELS[phase] || phase;
}

/** mm-dd-yyyy h:mm AM/PM */
export function formatNotificationDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return `${mm}-${dd}-${yyyy} ${time}`;
}

function defaultFailureMessage(jobType) {
  const jt = String(jobType || '').toLowerCase();
  if (jt === 'batch_upload') {
    return 'Documents were processed but results could not be saved. Open the student report and try Re-run Compliance.';
  }
  if (jt === 'rerun_compliance') {
    return 'The compliance re-run did not finish. Open the student report and try again.';
  }
  return 'Compliance processing did not complete. Open the student report for details.';
}

/** Client-side fallback for older notifications stored with raw errors. */
export function displayNotificationBody(item) {
  const body = item?.body;
  if (!body) return '';

  const phase = (item?.event_phase || '').toLowerCase();
  const titleFailed = String(item?.title || '').toLowerCase().includes('failed');
  const isFailed = phase === 'failed' || titleFailed;

  if (!isFailed) return body;

  const lower = String(body).toLowerCase();
  if (lower.includes('uniqueviolation') || lower.includes('duplicate key')) {
    return 'This compliance cycle was already saved. Open the student report to review results.';
  }
  if (TECHNICAL_MARKERS.some((m) => lower.includes(m))) {
    return defaultFailureMessage(item?.job_type);
  }
  if (String(body).length > 200 || String(body).startsWith('(')) {
    return defaultFailureMessage(item?.job_type);
  }
  return body;
}
